"use client"

import { ExternalLink } from "lucide-react"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { DialogFooter } from "@/components/ui/dialog"
import { useTranslations } from "next-intl"
import { TranslationText } from "@/components/i18n/translation-text"



export function MetaAdsCrmAccessStep({
  businessName,
  businessSettingsUrl,
  pageName,
  onConfirmed,
}: {
  businessName: string | null
  businessSettingsUrl: string
  pageName: string
  onConfirmed: () => void
}) {
  const tUi = useTranslations("Integrations.IntegrationsMetaAdsMetaAdsCrmAccessStep")

  return (
    <div className="space-y-4">
      <Alert>
        <AlertTitle><span key={tUi("step3GiveVersafyAccessToYourLeads")}>{tUi("step3GiveVersafyAccessToYourLeads")}</span></AlertTitle>
        <AlertDescription className="space-y-3">
          <p>
            <span key={tUi("metaRequiresThisFinalApprovalBeforeItWill")}>{tUi("metaRequiresThisFinalApprovalBeforeItWill")}</span></p>
          <ol className="list-decimal space-y-2 pl-5">
            <li>
              <span><span key={tUi("openMetaBusinessSettings")}>{tUi("openMetaBusinessSettings")}</span></span>
              {businessName ? <><TranslationText>{tUi.rich("forTag0Value0Tag0", { value0: String(businessName), tag0: chunks => (<strong>{chunks}</strong>) })}</TranslationText></> : ""}<span>.</span>
            </li>
            <li>
              <span><span key={tUi("select")}>{tUi("select")}</span></span> <strong>{pageName}</strong><span><span key={tUi("thenOpen")}>{tUi("thenOpen")}</span></span>
              <strong> <span key={tUi("integrationsLeadsAccessCRMs")}>{tUi("integrationsLeadsAccessCRMs")}</span></strong><span>.</span>
            </li>
            <li>
              <span><span key={tUi("select")}>{tUi("select")}</span></span> <strong><span key={tUi("assignCRM")}>{tUi("assignCRM")}</span></strong><span><span key={tUi("choose")}>{tUi("choose")}</span></span> <strong><span key={"Versafy"}>{"Versafy"}</span></strong><span><span key={tUi("andSave")}>{tUi("andSave")}</span></span>
            </li>
          </ol>
        </AlertDescription>
      </Alert>

      <DialogFooter className="sticky bottom-0 z-10 -mx-6 -mb-6 border-t bg-background px-6 py-4">
        <Button asChild type="button" variant="outline">
          <a href={businessSettingsUrl} target="_blank" rel="noreferrer">
            <span><span key={tUi("openMetaBusinessSettings")}>{tUi("openMetaBusinessSettings")}</span></span>
            <ExternalLink aria-hidden="true" className="ml-2 h-3.5 w-3.5" />
          </a>
        </Button>
        <Button type="button" onClick={onConfirmed}>
          <span key={tUi("iAssignedVersafy")}>{tUi("iAssignedVersafy")}</span></Button>
      </DialogFooter>
    </div>
  )
}
